import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class EditorialRelatedEditorials {
	constructor(elm) {
        this.elm = elm;

        this.relatedEditorialsInner = this.elm.querySelector('[data-related-editorials-inner]');
        if(this.relatedEditorialsInner) {
            this.init();
        }
    }

    init() {

		let mm = gsap.matchMedia();
        mm.add({
            isDesktop: `(min-width: 992px)`,
            isMobile: `(max-width: 991px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)",
            hasHover: "(hover: hover) and (pointer: fine)"
        }, (context) => {

            let { isDesktop, isMobile, reduceMotion, hasHover } = context.conditions;

            if(isDesktop) { // Desktop

				this.tl = gsap.timeline({
					paused: true
				});
				this.tl.fromTo(this.relatedEditorialsInner, {
					opacity: 0,
					translateY: '-75%',
				}, {
					opacity: 1,
					translateY: 0,
					duration: 1,
					ease: 'none',
				});

				this.trigger = ScrollTrigger.create({
					trigger: this.elm,
					start: "top bottom",
					end: "bottom bottom",
                    onUpdate: (self) => {
						this.tl.progress(self.progress, false);
					},
				});

			} else { // Mobile
				gsap.set(this.relatedEditorialsInner, {
					opacity: 1,
					translateY: 0
				});
			}

		});

    }

    destroy() {
        if(this.trigger) {
        	this.trigger.kill();
		}
    }

}